<p-dialog
  #fastPlanoSaude
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar plano de saúde</span>
      <i class="mdi mdi-hospital-building ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label for="inputtext-descricao">Descrição</mat-label>
        <input
          id="inputtext-descricao"
          class="input-filters"
          matInput
          [formControl]="form.get('descricao')"
          (blur)="actionFnCheckEntityExist(form.get('descricao'), 'descricao')"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('duplicate')"
      >
        {{ displayMessage.descricao.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-9 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label for="inputtext-descricao">Protocolo</mat-label>
        <input
          id="inputtext-protocolo"
          class="input-filters"
          matInput
          [formControl]="form.get('protocolo')"
          (blur)="actionFnCheckEntityExist(form.get('protocolo'), 'protocolo')"
          type="text"
          autocomplete="off"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('protocolo').hasError('duplicate')"
      >
        {{ displayMessage.protocolo.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('protocolo').hasError('required')">
        {{ displayMessage.protocolo.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('protocolo').hasError('maxlength')"
      >
        {{ displayMessage.protocolo.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('protocolo').hasError('isEmptyValue')"
      >
        {{ displayMessage.protocolo.isEmptyValue }}
      </small>
    </div>
    <div (click)="vlUnt.select()" class="col-md-3 mt-3">
      <mat-form-field
        class="width-100"
        appearance="outline"
        (click)="vlUnt.select()"
      >
        <mat-label (click)="vlUnt.select()">Valor</mat-label>
        <input
          #vlUnt
          matInput
          (click)="vlUnt.select()"
          mask="separator.2"
          decimalMarker=","
          separatorLimit="1000000000000"
          type="text"
          [formControl]="form.get('valor')"
          style="text-align: right;"
        />
        <span matPrefix *ngIf="!form.get('is_porcentagem').value">
          R$&nbsp;
        </span>
        <span matSuffix *ngIf="form.get('is_porcentagem').value">
          &nbsp;%&nbsp;
        </span>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('valor').hasError('invalidNumber')"
      >
        {{ displayMessage.valor.invalidNumber }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('required')">
        {{ displayMessage.valor.required }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('valueMinZero')">
        {{ displayMessage.valor.valueMinZero }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('menor_valor')">
        {{ displayMessage.valor.menor_valor }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('notNumbers')">
        {{ displayMessage.valor.notNumbers }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('before_split')">
        {{ displayMessage.valor.before_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('after_split')">
        {{ displayMessage.valor.after_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorComma')">
        {{ displayMessage.valor.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorDots')">
        {{ displayMessage.valor.errorDots }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('max_value')">
        {{ displayMessage.valor.max_value }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('valor').hasError('existSpecialChar')"
      >
        {{ displayMessage.valor.existSpecialChar }}
      </small>
    </div>
    <div class="col-md-6 mt-3">
      <mat-form-field appearance="outline" class="width-100">
        <mat-label>Tipo do valor</mat-label>
        <mat-select [formControl]="form.controls.is_desconto">
          <mat-option *ngFor="let i of tipoDesconto" [value]="i.value">
            {{ i.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('is_desconto').hasError('required')"
      >
        Tipo do valor é obrigatório
      </small>
    </div>
    <div class="col-md-6 mt-3">
      <mat-form-field appearance="outline" class="width-100">
        <mat-label>Forma do valor</mat-label>
        <mat-select [formControl]="form.controls.is_porcentagem">
          <mat-option *ngFor="let i of tipoValor" [value]="i.value">
            {{ i.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="form.get('is_porcentagem').hasError('required')"
      >
        Forma do valor é obrigatória
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <textarea
          rows="8"
          cols="118"
          pInputTextarea
          style="resize: none;"
          id="inputtext-observacao"
          [formControl]="form.get('observacao')"
          class="input-filters"
        ></textarea>
        <label for="inputtext-observacao">Observação</label>
      </span>
      <mat-hint
        class="flex width-100 justify-content-end"
        *ngIf="form.get('observacao').valid"
      >
        {{
          form.controls.observacao.value
            ? form.controls.observacao.value.length
            : 0
        }}/500
      </mat-hint>
      <small
        class="p-error"
        *ngIf="form.get('observacao').hasError('maxlength')"
      >
        {{ displayMessage.observacao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('observacao').hasError('isEmptyValue')"
      >
        {{ displayMessage.observacao.isEmptyValue }}
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
